import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { Button } from "@src/shared/components/Button/Button";

import styles from "./ExitStructuredFormModal.module.scss";

interface Props {
  open: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ExitStructuredFormModal = ({
  open,
  isLoading,
  onClose,
  onConfirm,
}: Props) => {
  return (
    <Dialog
      open={open}
      onClose={isLoading ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      classes={{
        paper: styles.paper,
      }}
    >
      <DialogTitle className={styles.title}>
        Закрыть форму?
      </DialogTitle>

      <DialogContent className={styles.content}>
        <p className={styles.text}>
          После структурирования вакансии при выходе из формы попытка будет списана. Закрыть форму?
        </p>
      </DialogContent>

      <DialogActions className={styles.actions}>
        <Button
          btnText="Отмена"
          typeBtn="button"
          onClick={onClose}
          isDisabled={isLoading}
        />

        <Button
          btnText="Закрыть форму"
          typeBtn="button"
          onClick={onConfirm}
          isDisabled={isLoading}
        />
      </DialogActions>
    </Dialog>
  );
};